<template>
<div class="chapter">
<div class="inner_page">
<p class="ind" id="epigraph" style="margin-top:20px;">He wasn’t really happy; he was only watching happiness from close to instead of from far away.</p>
<p class="right">—Graham Green,</p>
<p class="right">“The Basement Room”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4epigraph.vue?49120ad6